export default __webpack_public_path__ + "static/media/tundra_search.b93a86e4.svg";